import { CollaborationModalFactory } from '@services/MarppleShop/renderApp/components/cells/Collaboration/CollaborationModal.ts';
import { CollaborationController } from '@services/MarppleShop/renderApp/components/cells/Collaboration/CollaborationController.ts';
import { Modal, ModalClosedEvent } from '@services/MarppleShop/renderApp/components/atoms/Modal/Modal.ts';
import { View } from 'rune-ts';
import { CreatorSearchCard } from '@services/MarppleShop/renderApp/components/cells/CreatorSearchCard/CreatorSearchCard.ts';
import { BecomeFanButtonController } from '@services/MarppleShop/renderApp/components/cells/CreatorMainProfile/controllers/BecomeFanController.ts';
import { goLogin } from '@services/MarppleShop/shared/util/goLogin.ts';
import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';

export class SearchPageController {
  private collaborationModalFactory: CollaborationModalFactory;

  public collaborationController: CollaborationController;

  public collaborationModalView: Modal;

  constructor(private readonly layout_options: BaseLayoutOptions) {
    this.collaborationController = new CollaborationController({
      creator_name: '',
      is_mobile: this.layout_options.is_mobile,
    });

    this.collaborationModalFactory = new CollaborationModalFactory({
      collaborationController: this.collaborationController,
    });

    this.collaborationModalView = this.collaborationModalFactory.getModal();
  }

  public delegateProposalCollaboration(view: View) {
    view.addEventListener(CreatorSearchCard.ProposalButtonClickEvent, (e) => {
      const { name } = e.detail;
      this.collaborationModalView.open();
      this.collaborationController.setCreatorName(name || '');
      this.collaborationModalView.scrollBodyTo(0, 0);
    });

    view.addEventListener(ModalClosedEvent, () => {
      this.collaborationController.resetFormData();
    });

    this.collaborationController.delegateFormChangeEvent(
      this.collaborationModalView,
      this.collaborationController.changeSubmitButtonByValidation,
    );

    this.collaborationController.delegateSubmitEvent(this.collaborationModalView, () => {
      this.collaborationModalView.close();
    });

    this.collaborationController.delegateCancelEvent(this.collaborationModalView, () => {
      this.collaborationModalView.close();
    });
  }

  public delegateFanLetterButtonClick(view: View) {
    view.delegate(CreatorSearchCard.FanButtonClickEvent, CreatorSearchCard, async (e, Card) => {
      if (this.layout_options.user?.id) {
        const { id, is_liked } = e.detail;

        Card.setLikeState(!!is_liked);

        BecomeFanButtonController.postLike({ is_liked: !!is_liked, store_id: id }, () => {
          Card.setLikeState(!is_liked);
        });
      } else {
        await goLogin();
      }
    });
  }
}
